import { ReactNode } from "react";

// MUI
import { Dialog, DialogTitle, IconButton, DialogContent, Stack, Typography, Divider } from "@mui/material";

// Icons
import CloseIcon from "@mui/icons-material/Close";

// styles
import "./styles.css";

type GeneralDialogProps = {
	open: boolean;
	onClose: () => void;
	title: string | ReactNode;
	iconTitle: ReactNode;
	children: ReactNode;
	className?: string;
	sx?: object;
	disableClickOut?: boolean;
	showDivider?: boolean;
	closeButtonClasses?: string;
};
const GeneralDialog = ({
	open,
	onClose,
	title,
	iconTitle,
	className,
	children,
	sx,
	disableClickOut,
	showDivider = true,
	closeButtonClasses,
}: GeneralDialogProps) => {
	const onAvoidClose = () => null;
	return (
		<Dialog
			open={open}
			onClose={(_event, reason) => {
				if (reason === "backdropClick" && disableClickOut) {
					onAvoidClose();
				} else {
					onClose();
				}
			}}
			aria-labelledby={"dialog-title"}
			className={className ?? "general-dialog"}
			scroll={"paper"}
			disableEscapeKeyDown
			sx={{ ...sx }}
		>
			<DialogTitle id="general-dialog-title" height={"60px"}>
				<Stack direction="row" justifyContent={"space-between"} alignItems={"flex-start"}>
					<Stack direction="row" justifyContent={"flex-start"} alignItems={"center"} spacing={1}>
						{title && iconTitle}
						<Typography className={"regular-montserrat-label fs-24"}>{title}</Typography>
					</Stack>
					<IconButton
						aria-label="close"
						onClick={onClose}
						sx={{ marginRight: title ? "-17px" : "-12px", marginTop: title ? "-3px" : 0 }}
						className={closeButtonClasses}
					>
						<CloseIcon sx={{ color: "#CCCCCC" }} />
					</IconButton>
				</Stack>
			</DialogTitle>
			{title && showDivider ? <Divider className="!border-disabled" variant="fullWidth" sx={{ borderWidth: "1px" }} /> : null}
			<DialogContent
				sx={{
					maxHeight: "1000px",
				}}
			>
				{children}
			</DialogContent>
		</Dialog>
	);
};

export default GeneralDialog;
